import { GetAgencyStatus, EditAgencyStatus,InsertAgencyStatus, DELETEAgencyStatus } from "../type";
const initialState = {
  getAgencyStatus: [],
  InsertAgencyStatus: [],
  UpdateAgencyStatus: [],
  DeleteAgencyStatus: [],
  loading: true,
};
const AgencyStatusR = (state = initialState, action) => {
  switch (action.type) {
    case GetAgencyStatus:
      return {
        ...state,
        getAgencyStatus: action.payload,
        loading: false,
      };
    case InsertAgencyStatus:
      return {
        getAgencyStatus: state.getAgencyStatus,
        InsertAgencyStatus: action.payload,
        loading: false,
      };
      case EditAgencyStatus:
        return {
          getAgencyStatus: state.getAgencyStatus,
          UpdateAgencyStatus: action.payload,
          loading: false,
        };
        case DELETEAgencyStatus:
          return {
            getAgencyStatus: state.getAgencyStatus,
            DeleteAgencyStatus: action.payload,
            loading: false,
          };
    default:
      return state;
  }
};
export default AgencyStatusR;
